import Tooltip from "components/tooltip/tooltip"

export default function WindStateTooltipPlugin($pool) {
  return function run(eventName, payload) {
    const { tableName, node } = payload
    if (eventName !== "Table:connectHeaders") return
    if (tableName !== "advanced") return

    $pool.push("Table:connectHeaders::finish", () => {
      Array.from(node.querySelectorAll("[data-tooltip-text], [data-tooltip-content-id]")).forEach(
        (el) => {
          const tooltip = new Tooltip(el)
          tooltip.init()
        },
      )
    })
  }
}
